export default {
  standardFontRegular: 'Poppins-Regular',
  standardFontMedium: 'Poppins-Medium',
  standardFontSemiBold: 'Poppins-SemiBold',
  standardFontLight: 'Poppins-Light',
  standardFontThin: 'Poppins-Thin',
  standardFontBold: 'Poppins-Bold',
  standardFontBlack: 'Poppins-Black',
};